<template>
  <h1
    class="text-4xl tracking-tight leading-10 font-display font-extrabold text-gray-900 sm:text-5xl sm:leading-none md:text-6xl"
    data-test="logo"
  >
    <span
      class="bg-clip-text text-transparent bg-gradient-to-r from-teal-400 to-orange-400 via-purple-400"
    >
      <slot>
        carousel
      </slot>
    </span>
  </h1>
</template>
